export default __webpack_public_path__ + "static/media/ApplePayWhiteBorder.97ed51a4.svg";